/* ============================================================
   WCAG 1.4.13 Fix - Flow Theme Navigation
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  var desktopItems = document.querySelectorAll('#AccessibleNav .site-nav--has-dropdown');

  desktopItems.forEach(function(item) {
    var dropdown = item.querySelector('.site-nav__dropdown');
    if (!dropdown) return;

    var trigger = item.querySelector('a.site-nav__link');
    var closeTimer = null;

    function openDropdown() {
      clearTimeout(closeTimer);
      item.classList.add('nav-dropdown--open');
      dropdown.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      item.classList.remove('nav-dropdown--open');
      dropdown.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose() {
      closeTimer = setTimeout(closeDropdown, 150);
    }

    item.addEventListener('mouseenter', openDropdown);
    item.addEventListener('mouseleave', scheduleClose);
    dropdown.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
    dropdown.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focusin', openDropdown);
    item.addEventListener('focusout', function(e) {
      if (!item.contains(e.relatedTarget)) closeDropdown();
    });
    item.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeDropdown(); if (trigger) trigger.focus(); }
    });
  });

  var mobileItems = document.querySelectorAll('.mobile-nav__item.top-level');

  mobileItems.forEach(function(item) {
    var sublist = item.querySelector('.mobile-nav__sublist');
    if (!sublist) return;

    var toggleBtn = item.querySelector('.mobile-nav__toggle-open');

    item.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        sublist.setAttribute('aria-hidden', 'true');
        if (toggleBtn) { toggleBtn.setAttribute('aria-expanded', 'false'); toggleBtn.focus(); }
      }
    });

    item.addEventListener('focusout', function(e) {
      if (!item.contains(e.relatedTarget)) {
        sublist.setAttribute('aria-hidden', 'true');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });

});
